"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/PersonalInfo/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');
var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);


var _smsNotice = require('shared/constants/smsNotice');



var _signup = require('shared/validation/signup');





var _Form = require('web/components/Form');
var _AuthFrame = require('web/components/AuthFrame');
var _components = require('web/screens/Signup/components');











const makeDefaultValues = (welcomeUser) => ({
  firstName: _optionalChain([welcomeUser, 'optionalAccess', _ => _.FirstName]) || '',
  lastName: _optionalChain([welcomeUser, 'optionalAccess', _2 => _2.LastName]) || '',
  email: _optionalChain([welcomeUser, 'optionalAccess', _3 => _3.Email]) || '',
  phone: _optionalChain([welcomeUser, 'optionalAccess', _4 => _4.PhoneNumber]) || '',
})

const PersonalInfoSection = ({
  isPhoneRequired,
  shouldShowPhone,
  onSubmit,
  welcomeUser,
  personalInfo,
  error,
}) => {
  const defaultValues = _react.useMemo.call(void 0, 
    () => personalInfo || makeDefaultValues(welcomeUser),
    [personalInfo, welcomeUser],
  )

  const phonePolicy = _nullishCoalesce(_optionalChain([welcomeUser, 'optionalAccess', _5 => _5.PhonePolicy]), () => ( 'strict'))
  const resolver = _react.useMemo.call(void 0, 
    () => _signup.getPersonalInfoResolver.call(void 0, isPhoneRequired, phonePolicy),
    [isPhoneRequired, phonePolicy],
  )
  const { register, handleSubmit, formState, reset, control, getValues } = _reacthookform.useForm.call(void 0, {
    resolver,
    // Validate a field when it loses focus, then as it is edited to clear the
    // error: never while its first value is still being typed.
    mode: 'onTouched',
    defaultValues,
  })
  const { isSubmitting, isValid } = formState
  // Shown once they leave a field after typing, never while they type.
  const display = _useFieldErrorDisplay2.default.call(void 0, {
    firstName: formState.errors.firstName,
    lastName: formState.errors.lastName,
    email: formState.errors.email,
    phone: formState.errors.phone,
  })

  // Continue saves what was typed before it texts the code, which hands the
  // same values back here. Resetting to them would clear isSubmitting and drop
  // the "Sending code…" state, so only reset to values that differ.
  _react.useEffect.call(void 0, () => {
    if (JSON.stringify(getValues()) === JSON.stringify({ ...getValues(), ...defaultValues })) return
    reset(defaultValues)
  }, [reset, getValues, defaultValues])

  let subtitle = 'Enter your name and email contact.'
  if (shouldShowPhone) {
    subtitle = isPhoneRequired
      ? 'Enter your name and phone contact.'
      : 'Enter your name and optionally add a phone contact.'
  }

  const phoneHint = isPhoneRequired
    ? 'We keep your number safe and just need it so your co-workers are able to message you through BloomText.'
    : "Adding a phone number is optional. If you add one, we'll verify it before saving it to your account."
  const phoneError = _optionalChain([display, 'access', _6 => _6.shown, 'call', _7 => _7('phone'), 'optionalAccess', _8 => _8.message]) || error
  // Continuing with a new phone texts it a code first.
  const isSendingCode = isSubmitting && shouldShowPhone

  return (
    _react2.default.createElement('form', { onSubmit: handleSubmit(onSubmit, errs => display.onSubmitErrors(Object.keys(errs))), __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
      , _react2.default.createElement(_components.SignupStepHeader, {
        title: "Tell us about yourself"   ,
        subtitle: subtitle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
      )
      , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
        , _react2.default.createElement(_Form.InputSection, {
          autoFocus: true,
          autoComplete: "given-name",
          title: "First name" ,
          placeholder: "E.g. Jordan" ,
          inputProps: display.bind(register('firstName')),
          errorMessage: _optionalChain([display, 'access', _9 => _9.shown, 'call', _10 => _10('firstName'), 'optionalAccess', _11 => _11.message]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
        )
        , _react2.default.createElement(_Form.InputSection, {
          autoComplete: "family-name",
          title: "Last name" ,
          placeholder: "E.g. Rivera" ,
          inputProps: display.bind(register('lastName')),
          errorMessage: _optionalChain([display, 'access', _12 => _12.shown, 'call', _13 => _13('lastName'), 'optionalAccess', _14 => _14.message]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
        )
      )
      ,  shouldShowPhone
        ? (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement(_Form.InputSectionWrapper, {
                title: "Mobile phone" ,
                desc: phoneHint,
                errorMessage: phoneError, __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}

                , _react2.default.createElement(_Form.PhoneInputController, {
                  control: control,
                  name: "phone",
                  autoFocus: false,
                  hasError: !!phoneError,
                  onType: () => display.onType('phone'),
                  onLeave: value => display.onLeave('phone', value),
                  phonePolicy: phonePolicy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
                )
              )
              , _react2.default.createElement('p', { className: "signup-step--sms-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}, _smsNotice.SMS_TRANSACTIONAL_PHONE_NOTICE)
            )
          )
        : _react2.default.createElement(_Form.InputSection, {
            title: "Email",
            autoComplete: "email",
            placeholder: "name@clinic.com",
            inputProps: display.bind(register('email')),
            errorMessage: _optionalChain([display, 'access', _15 => _15.shown, 'call', _16 => _16('email'), 'optionalAccess', _17 => _17.message]),
            className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}
          )
      
      ,  !shouldShowPhone && error && _react2.default.createElement(_AuthFrame.Callout, { message: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}} ) 
      , _react2.default.createElement(_components.SignupStepControls, {
        isNextDisabled: !isValid || isSubmitting,
        isNextLoading: isSubmitting,
        nextBtnLabel: isSendingCode ? 'Sending code…' : 'Continue', __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}}
      )
    )
  )
}

exports. default = PersonalInfoSection
